import { baseApi } from '@shared/api/baseApi'
import type { RecentViewsResponse } from '../types'

/**
 * Сколько позиций просим. Бэк принимает 1..50 и на выход за границы отвечает
 * 422, а не подгоняет молча — поэтому значение держим здесь и не собираем из
 * пользовательского ввода.
 */
export const RECENT_VIEWS_LIMIT = 10

/**
 * Недавно просмотренные карточки, от свежих к старым.
 *
 * Отдаёт только идентификаторы и время открытия: сами карточки фронт берёт из
 * `/content/cards`, которые и так загружены.
 */
export const getRecentViews = async (
  limit: number = RECENT_VIEWS_LIMIT
): Promise<RecentViewsResponse> => {
  const { data } = await baseApi.get<RecentViewsResponse>('/api/user/recent', {
    params: { limit },
  })
  return data
}
